// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3LYA1","question":"Question_question__figtq","description":"Question_description__2QmPd"};